'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * DialogBlock component, used to separate content in a Dialog.
 *
 * @example
 * <Dialog>
 *   <Dialog.Block>
 *     Header
 *   </Dialog.Block>
 *   <Dialog.Block>
 *     Content
 *   </Dialog.Block>
 *   <Dialog.Block>
 *     Footer
 *   </Dialog.Block>
 * </Dialog>
 */
const DialogBlock = forwardRef(function DialogBlock({ asChild, className, ...rest }, ref) {
    const Component = asChild ? Slot : 'div';
    return (jsx(Component, { className: cl('ds-dialog__block', className), ref: ref, ...rest }));
});

export { DialogBlock };
